import React from 'react'
import { graphql } from 'gatsby'
import { Container } from 'react-bootstrap'
import { AkBannerInstance } from 'ak_banner'

import Logo from '../images/ausgetauscht-logo.png'
import PageLayoutProvider from '../components/PageLayoutProvider'
import Seo from '../components/Seo'
import Sections from '../components/Sections'
import OffcanvasMenu from '../components/OffcanvasMenu'
import BackToTop from '../components/BackToTop'

const OrganisationPageTemplate = ({ data }) => {

  const page = data.page

  return (
    <React.StrictMode>
      <PageLayoutProvider className='organisation-page'>
        <BackToTop>
          <OffcanvasMenu className='mb-5 navbar-transparent-overlay' />
          <AkBannerInstance bannerType={'skyscraper'} />
          <Container>

            <AkBannerInstance bannerType={'mobile_leaderboard'}/>
            <AkBannerInstance bannerType={'leaderboard'} />

            <div className='page-head'>
              <img src={ page.image_url } alt={`logo`} className='mb-5' width='200' height='200' />
              <h1>
                { page.subline && (
                  <>
                    <small>{page.subline} </small>
                    <br />
                  </>
                )}
                {page.headline}
              </h1>
            </div>
          </Container>

          <Sections sections={ page.sections } />
        </BackToTop>
      </PageLayoutProvider>
    </React.StrictMode>
  )
}

export const query = graphql`
  query($pagePath: String!) {
    site {
      siteMetadata {
        siteUrl
      }
    }
    page(path: {eq: $pagePath}) {
      id
      abstract
      headline
      subline
      lead_text
      layout
      path
      image_url
      sections {
        id
        headline
        body
        lead_text
        display_mode
        image_id
        image_url
        image_gravity
        parent {
          ... on Page {
            layout
          }
        }
        position
        target_link_text
        target_page_path
        target_url
        items {
          id
          headline
          body
          image_url
          target_link_text
          target_page_path
          target_url
          image_gravity
          parent {
            ... on Section {
              parent {
                ... on Page {
                  layout
                }
              }
            }
          }
          component_config
          component_name
          has_component
          component {
            name
              ... on AkOrganisationsComponentConfiguration {
                countryCode
                limit
                sortBy
                organisations {
                  shortname
                  slug
                  logo_url
                  rating_summary {
                    num_in_period
                    average
                    num_ratings
                  }
                }
              }
              ... on FeaturePlacementsComponentConfiguration {
                linkText
                context
              }
              ... on SchNetProgramsComponentConfiguration {
                countryCode
                startYear
                duration
              }
          }
          position
          display_mode
        }
      }
      meta_data {
        meta_title
        meta_description
        meta_keywords
      }
    }
    site {
      siteMetadata {
        siteUrl
      }
    }
  }
`

export default OrganisationPageTemplate

export const Head = ({
  data: {
    site: {
      siteMetadata: {
        siteUrl
      }
    },
    page: {
      headline,
      meta_data,
    }
  }
}) => (
  <Seo
    title={ meta_data.meta_title || headline }
    description={ meta_data.meta_description }
    keywords={ meta_data.meta_keywords }
    meta={ { property: 'og:image', content: `${siteUrl}${Logo}` } }
  />
)
